class BrandTestimonialSection {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.section = document.querySelector(`#shopify-section-${sectionId}`);
    if (this.section) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const brandItems = this.section.querySelectorAll('.brand-testimonial__item');
    brandItems.forEach(item => {
      // Handle both Click and Focus events
      ['click', 'focus'].forEach(evt => {
        item.addEventListener(evt, (e) => {
          if (evt === 'click') e.preventDefault(); // Prevent default only on click
          const brandId = item.getAttribute('data-brand');
          this.setActiveBrand(brandId);
        });
      });
    });
  }

  setActiveBrand(brandId) {
    // Remove active class from all items
    const allItems = this.section.querySelectorAll('.brand-testimonial__item');
    allItems.forEach(item => {
      item.classList.remove('brand-testimonial__item--active');
    });

    // Add active class to the clicked/focused item
    const activeItem = this.section.querySelector(`[data-brand="${brandId}"]`);
    if (activeItem) {
      activeItem.classList.add('brand-testimonial__item--active');
    }

    // Hide all content
    const allContent = this.section.querySelectorAll('.brand-testimonial__content');
    allContent.forEach(content => {
      content.classList.remove('brand-testimonial__content--active');
    });

    // Show the corresponding content
    const activeContent = this.section.querySelector(`[data-content="${brandId}"]`);
    if (activeContent) {
      setTimeout(() => {
        activeContent.classList.add('brand-testimonial__content--active');
      }, 200);
    }
  }
}

// Initialize when DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="shopify-section-"]');
  sections.forEach(section => {
    if (section.querySelector('.brand-testimonial')) {
      const sectionId = section.id.replace('shopify-section-', '');
      new BrandTestimonialSection(sectionId);
    }
  });
});

// Re-initialize when Shopify theme editor reloads a section
document.addEventListener('shopify:section:load', (event) => {
  const sectionId = event.detail.sectionId;
  const section = document.querySelector(`#shopify-section-${sectionId}`);
  if (section && section.querySelector('.brand-testimonial')) {
    new BrandTestimonialSection(sectionId);
  }
});
